import { ref } from 'vue'
import { TOAST_DURATION } from '@/constants/ui'

interface ToastOptions {
  type?: 'success' | 'error' | 'warning' | 'info'
  title?: string
  message: string
  duration?: number
}

interface ToastItem {
  id: number
  type: string
  title: string
  message: string
}

export const toasts = ref<ToastItem[]>([])
let toastId = 0

export function removeToast(id: number): void {
  const index = toasts.value.findIndex(t => t.id === id)
  if (index > -1) {
    toasts.value.splice(index, 1)
  }
}

function show(options: ToastOptions): number {
  const id = ++toastId
  const { type = 'info', title = '', message = '', duration = TOAST_DURATION.DEFAULT } = options

  toasts.value.push({ id, type, title, message })

  if (duration > 0) {
    setTimeout(() => removeToast(id), duration)
  }

  return id
}

function success(message: string, title = '成功'): number {
  return show({ type: 'success', title, message })
}

function error(message: string, title = '错误'): number {
  return show({ type: 'error', title, message, duration: TOAST_DURATION.ERROR })
}

function warning(message: string, title = '警告'): number {
  return show({ type: 'warning', title, message, duration: TOAST_DURATION.WARNING })
}

function info(message: string, title = '提示'): number {
  return show({ type: 'info', title, message })
}

const Toast = {
  toasts,
  show,
  success,
  error,
  warning,
  info,
  remove: removeToast
}

export default Toast
